import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { getAllCoursesQueryKey } from './query.get-all.js';
import { getSingleCourseRequest } from './request.get-single.js';

function useSyncCourseMutation() {
  const client = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(syncCourseMutation(client, notifier, user));
}

/**
 * fetches updated content from the backend and update local copy
 */
const syncCourseMutation = (client, notifier, user) => {
  return {
    mutationKey: ["course-builder/sync", user?.id],
    mutationFn: courseId => getSingleCourseRequest(user, courseId),
    onSuccess: result => {
      client.setQueryData(getAllCoursesQueryKey(user), previous => previous?.map(course => course.id === result.id ? result : course));
    },
    onError: () => {
      notifier.notify({
        id: "course-builder.sync-course",
        type: "error",
        body: `Dine ændringer blev ikke synkroniseret. Vi anbefaler du genindlæser siden inden du arbejder videre med dit forløb.`
      });
    }
  };
};

export { useSyncCourseMutation };
//# sourceMappingURL=mutation.sync.js.map
